import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { getBlogCategories } from "@/data/site";
import { FileText } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function Blog() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta("Blog", L("Articoli su recupero wallet, sicurezza e prevenzione truffe.", "Articles on wallet recovery, security and fraud prevention.", "Artikel über Wallet-Wiederherstellung, Sicherheit und Betrugsprävention."));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/content/blog", { params: { status: "published" } })
      .then(({ data }) => setPosts(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHero eyebrow="Blog" title={L("Approfondimenti e guide", "Insights and guides", "Einblicke und Leitfäden")}
        subtitle={L("Contenuti informativi su sicurezza, wallet e prevenzione. Non costituiscono consulenza legale o finanziaria.", "Informational content on security, wallets and prevention. Not legal or financial advice.", "Informative Inhalte zu Sicherheit, Wallets und Prävention. Keine Rechts- oder Finanzberatung.")} />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="flex flex-wrap gap-2 mb-10">
          {getBlogCategories(lang).map((c) => (
            <span key={c} className="rounded-full border border-white/10 bg-navy-paper px-3 py-1 text-xs text-slate-400">{c}</span>
          ))}
        </div>
        {loading ? (
          <p className="text-slate-500">{L("Caricamento…", "Loading…", "Wird geladen…")}</p>
        ) : posts.length === 0 ? (
          <div className="rounded-xl border border-dashed border-white/15 bg-navy-paper p-12 text-center" data-testid="blog-empty">
            <FileText className="mx-auto h-8 w-8 text-slate-600" />
            <p className="mt-3 text-sm text-slate-400">{L("Nessun articolo pubblicato. Le bozze sono visibili solo agli amministratori.", "No articles published. Drafts are visible only to administrators.", "Keine Artikel veröffentlicht. Entwürfe sind nur für Administratoren sichtbar.")}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {posts.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="rounded-xl border border-white/10 bg-navy-paper p-6 hover:border-cyanx/30 transition-colors" data-testid={`blog-post-${p.slug}`}>
                <span className="text-xs text-cyanx">{p.category}</span>
                <h3 className="mt-2 font-heading text-lg font-medium text-white">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-400 line-clamp-3">{p.excerpt}</p>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
